import { Separator } from '@optools/components/ui/separator';
import { Link, Outlet } from '@tanstack/react-router';

export interface GameDetailNavigationProps {
  date: string;
  gamePk: number;
}
export function GameDetailNavigation({ date, gamePk }: GameDetailNavigationProps) {
  return (
    <div className="relative -ml-2 flex-1 overflow-auto pl-2" id="game-detail-navigation">
      <div className="sticky top-0 z-10 bg-background">
        <nav className="mb-2 flex gap-4">
          <Link
            className="text-current/70 underline decoration-transparent underline-offset-12 transition-colors duration-300 [&.active]:text-current [&.active]:decoration-current"
            from="/"
            params={{ gamePk }}
            replace
            search={{ date }}
            to="/btc-tools/schedule/$gamePk/pipelines">
            Pipelines
          </Link>
          <Link
            className="text-current/70 underline decoration-transparent underline-offset-12 transition-colors duration-300 [&.active]:text-current [&.active]:decoration-current"
            from="/"
            params={{ gamePk }}
            replace
            search={{ date }}
            to="/btc-tools/schedule/$gamePk/content">
            Content
          </Link>
          <Link
            className="text-current/70 underline decoration-transparent underline-offset-12 transition-colors duration-300 [&.active]:text-current [&.active]:decoration-current"
            from="/"
            params={{ gamePk }}
            replace
            search={{ date }}
            to="/btc-tools/schedule/$gamePk/broadcasts">
            Broadcasts
          </Link>
          <Link
            className="text-current/70 underline decoration-transparent underline-offset-12 transition-colors duration-300 [&.active]:text-current [&.active]:decoration-current"
            from="/"
            params={{ gamePk }}
            replace
            search={{ date }}
            to="/btc-tools/schedule/$gamePk/broadcast-acquisitions">
            Broadcast Acquisitions
          </Link>
        </nav>
        <Separator className="mb-2" />
      </div>

      <Outlet />
    </div>
  );
}
